<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body fluid="xl">
          <b-form @submit.stop.prevent="onSubmit">
            <b-row>
              <b-col lg="12">
                <b-alert show variant="light">Overdues By Satsangi Groups Report</b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <hr/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                 <b-form-group label="Sangtsangi Group" label-for="group">
                     <v-select autofocus ref="group" id="group" name="group" :class="{ danger: $v.form.group.$error }" @search:blur="$v.form.group.$touch()" :state="validateState('group')" :options="satsangiGroups"  aria-describedby="liveFeedbackgroup" v-model="$v.form.group.$model" :reduce="group => group.id" label="name"></v-select>
                     <span v-show="$v.form.group.$error" class="danger-span">
                       This is required field
                     </span>
                     <b-form-invalid-feedback id="liveFeedbackgroup">
                       This is a required field.
                     </b-form-invalid-feedback>
                 </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-button ref="submitButton" type="submit" variant="success" :disabled="$v.form.$invalid">
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
      </b-card-body>
    </b-card>
    <b-card v-if="reportData!=null && Object.keys(reportData).length > 0">
        <ag-grid-vue class="ag-theme-balham"
          :gridOptions="gridOptions"
          id="AmountDueByGroupGrid"
          :rowData="reportData"
          :pagination="true"
          :paginationPageSize="50"
          :suppressNoRowsOverlay="true"
          :floatingFilter="true"
          @gridReady="gridReady">
        </ag-grid-vue>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {AgGridVue} from "ag-grid-vue";
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import {
    mapState,
    mapActions
  } from 'vuex'

  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  const formShape = {
    group: null
  }

  export default {
    name: 'AmountDueByGroups',
    components: {
      AgGridVue
    },
    data: function() {
      return {
        submitted: false,
        form: Object.assign({}, formShape),
        reportData: null,
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
          },
          columnDefs: [
            {headerName: 'Profile Name', field: 'name', minWidth: 150,maxWidth: 300},
            {headerName: 'Address', field: 'houseno',minWidth: 120,maxWidth: 150},
            {headerName: 'Current Dues', field: 'periods.month1', filter: 'agNumberColumnFilter',minWidth: 150},
            {headerName: '3 Months Past Due', field: 'periods.month3',filter: 'agNumberColumnFilter',minWidth: 150},
            {headerName: '6 Months Past Due', field: 'periods.month6', filter: 'agNumberColumnFilter',minWidth: 150},
            {headerName: '9 Months Past Due', field: 'periods.month9',filter: 'agNumberColumnFilter',minWidth: 150},
            {headerName: '1 Year Past Due', field: 'periods.month12', filter: 'agNumberColumnFilter',minWidth: 150},
            {headerName: 'More Than Year', field: 'periods.oldyear',filter: 'agNumberColumnFilter',minWidth: 150},
            {headerName: 'Total', field: 'total',filter: 'agNumberColumnFilter',minWidth: 150}

         ]
       }
      }
    },
    computed: {
      satsangiGroups: function(){
        return this.$store.state.electrical.satsangiGroups;
      },
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },

    },
    validations: {
      form: {
        group: {
          required
        }
      }
    },
    methods:{
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      onSubmit() {
          if(this.isValid){
          this.$nextTick(() => {
            let params = {
              group: this.$v.form.group.$model.id
            }
            this.$store.dispatch('electrical/getAmountDueByGroup', params)
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                }
                else{
                  this.reportData = response.data.data
                  if(Object.keys(this.reportData).length > 0){
                    this.showSuccessMsg({
                      message: 'Records Retrieved successfully.'
                    });
                  }
                  else{
                    this.showSuccessMsg({
                      message: 'No Records Found for given criteria.'
                    });
                  }

                }
              })
              .catch((error) => {
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.message
                    });

                }
                else {
                  this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                }
              })

          })
        }

      },
      gridReady(){
         this.gridOptions.api.sizeColumnsToFit();
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
      validate() {
        this.$v.$touch()
        this.$nextTick(() => this.findFirstError())
        return this.isValid
      }
    },
    created() {
      if (this.$store.state.electrical.satsangiGroups.length == 0) {
        this.$store.dispatch('electrical/getSatsangiGroups')
      }
    },
  }
</script>

<style lang="css">
</style>
